import { render, staticRenderFns } from "./ReceiptTon.vue?vue&type=template&id=a2d0fb44&scoped=true"
import script from "./ReceiptTon.vue?vue&type=script&lang=js"
export * from "./ReceiptTon.vue?vue&type=script&lang=js"
import style0 from "./ReceiptTon.vue?vue&type=style&index=0&id=a2d0fb44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d0fb44",
  null
  
)

export default component.exports